export default "__VITE_ASSET__xom8d9Yx__"